/**
 * Active write-slot key for the `studyDays` counter entity.
 *
 * Fed by the auth provider's `sessionId` at the app root (see `setActiveSession`).
 * A session is single-writer per device-login, so using it as the per-day
 * `sessions` partition key guarantees concurrent devices never clobber each
 * other's counts — each device only ever writes its own slot, and the slots
 * are combined with `max` on merge (see `mergeStudyDay`). This is what makes
 * the counters offline- and multi-device-safe without per-event storage.
 */

let activeSessionId: string | null = null;

/**
 * Set the current auth session id. Call from a root effect that reads
 * `useAuth().sessionId`.
 */
export function setActiveSession(sessionId: string | null): void {
  activeSessionId = sessionId;
}

/**
 * The current write-slot key. Falls back to a constant when unauthenticated —
 * study only happens while signed in, so this is a defensive default and will
 * never collide with the synthetic `migration` slot used by the backfill.
 */
export function currentSession(): string {
  return activeSessionId ?? 'unknown';
}
